import moment from 'moment'

// Rounds a moment/Date DOWN to the nearest quarter-hour (00, 15, 30, 45).
// Zeros seconds and milliseconds so the scheduled time is exact.
// Accepts a moment instance or any value moment() can parse.
export const snapToQuarterHour = (date) => {
  const m = moment(date)
  const minutes = m.minute()
  const floored = Math.floor(minutes / 15) * 15
  return m.minute(floored).second(0).millisecond(0)
}
